// extracted by mini-css-extract-plugin
export default {"inputItem":"DiagnosisBlock_inputItem__+7ocJ","buttonRow":"DiagnosisBlock_buttonRow__dHSlB","submitButton":"DiagnosisBlock_submitButton__lLVXB"};